import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';
import { CardService } from '../../view/card/card.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-inputType-date',
  templateUrl: './inputType-date.component.html',
  styleUrls: ['./inputType-date.component.scss']
,  standalone: false
})
export class InputTypeDateComponent implements OnInit, OnChanges {
  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() showName?: boolean = true;
  @Input() IsReadOnly?: boolean = false;

  minLength: number = 0;
  maxLength: number = 999;
  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  isConditionIsTrue: boolean;
  validationPattern: string = "^[a-zA-Z0-9!@#$&%()\\-`.+,/\"]*$"
  checkallvalidations: string = "";
  numberPattern: string = "0-9";
  alphabetsPattern: string = "A-Za-z";
  specialCharactersPattern: string = "!@#$&()\\-`.+,/\"*$%_^";
  isNumberValidation: boolean = false;
  isCharactersValidation: boolean = false;
  isSpecialCharactersValidation: boolean = false;
  excludeCharacters: string;
  isExcludeCharactersValidation: boolean = false;
  FutureDateEnabled: boolean = false;
  PastDateEnabled: boolean = false;
  TodayDateEnabled: boolean = false;
  // @Input() foregroundcolor: string;
  // @Input() backgroundcolor: string;
  // @Input() theme: string;
  // @Input() controlBGColor: string;
  // @Input() controlBorder: string;
  // @Input() TextColor: string;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  //controlColor: string;

  varInterval: any;
  selectedDate: any;
  selectedTime: any
  dateFlag: boolean = false;
  timeFlag: boolean = false;

  private resetSubscription: Subscription;

  constructor(public datepipe: DatePipe, private cardService: CardService) { }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion }; // Create a new reference to trigger change detection
      if (this.question.responseText && this.question.responseText.length > 0) {
        this.setIntialResponseValue();
      }
      else{
        this.selectedDate = ''; this.selectedTime = '';
        this.question["IsValid"] = (this.question.isQuestionRequired == "Y") ? false : true;     
      }
    }
  }

  ngOnDestroy() {
    clearInterval(this.varInterval);

    if (this.resetSubscription) {
      this.resetSubscription.unsubscribe();
    }
  }
  ngDoCheck() {
    if (this.question.errorMessage) {
      if (this.question["responseText"] && this.question["responseText"] != '' && this.question["responseText"] != undefined) {
        let newDate = new Date(this.question["responseText"]);
        this.CheckValidations(newDate);
      }
      else if(this.question.isQuestionRequired=='Y')
      {
        let found = this.validationerrormessage.find(x=> x == 'Input is mandatory');
        if(found == null){
          this.validationerrormessage.push("Input is mandatory");
        }
        this.errormgvisible = true;
      }
    }
  }

  clearDateOrTime() {
    this.selectedDate = null; this.selectedTime = null; 
    this.dateFlag = false; this.timeFlag = false;
  }
  ngOnInit() {
    this.question["IsValid"] = true;
    this.validationerrormessage = [];
    this.errormgvisible = false;
    this.resetSubscription = this.cardService.resetDate$.subscribe(() => {
      this.clearDateOrTime();
    });
    if (this.question.isQuestionRequired == "Y") {
      this.isConditionIsTrue = true;
    }
    else {
      this.isConditionIsTrue = false;
    }
    if (this.question.futureDateEnabled) { this.FutureDateEnabled = true; }

    if (this.question.pastDateEnabled) { this.PastDateEnabled = true; }

    if (this.question.todayDateEnabled) { this.TodayDateEnabled = true; }

    this.question.validationDetails.forEach((obj, index) => {
      //to add number pattern only once
      if (this.isNumberValidation === false) {
        if (obj.isNumericAllowed === true) {
          this.isNumberValidation = true;
          this.checkallvalidations += this.numberPattern;
        }
      }
      if (this.isCharactersValidation === false) {
        if (obj.isCharacterAllowed === true) {
          this.isCharactersValidation = true;
          this.checkallvalidations += this.alphabetsPattern;
        }
      }
      if (this.isSpecialCharactersValidation === false) {
        if (obj.isSpecialCharacterAllowed === true) {
          this.isSpecialCharactersValidation = true;
          this.checkallvalidations += this.specialCharactersPattern;
        }
      }
      if (this.isExcludeCharactersValidation === false) {
        if (obj.excludeCharacters != null && obj.excludeCharacters != "") {
          this.isExcludeCharactersValidation = true;
          this.excludeCharacters = obj.excludeCharacters;
        }
      }
      this.validationerrormessage.push(obj.errorMessage);
      //check min length and max length
      if (obj.minRange != null && obj.minRange >= 0 && obj.maxRange != null && obj.maxRange > 0) {
        this.minLength = obj.minRange;
        this.maxLength = obj.maxRange;

      }
      if (obj.regularExpression != null && obj.regularExpression != "") {
        this.validationPattern = obj.regularExpression + "{1,999}";
      }
    });
    if (this.checkallvalidations != "" && this.checkallvalidations != null) {
      this.validationPattern = "[" + this.checkallvalidations + "]{1,999}"
    }

    if (this.question["responseText"] && this.question["responseText"] != '') {
      // let newDate = new Date(this.question["responseText"]);   
      // this.CheckValidations(newDate);    
      this.setIntialResponseValue();
    }
    else {
      this.selectedDate = ''; this.selectedTime = '';
      if (this.question.isQuestionRequired == "Y") {
        this.question["IsValid"] = false;
      }
      else {
        this.question["IsValid"] = true;
      }
    }

     this.checkForConsentScreen();
  }
  checkForConsentScreen() {
    if (this.question.isConsentQuestion && this.question.consentQuestionLabel != null && this.question.consentQuestionLabel.length > 0  ) {
      this.question.safeHtmlContent = this.question.consentQuestionLabel;
    }
  }

  setIntialResponseValue() {
    
    let newDateTime = this.question["responseText"];

    if (this.question.timeEnabled) {
      let x = newDateTime.split(' ');
      let dt = x[0];
      let time = x[1];

      //accepted values '2013-08-19' , '22:53'
      //convert date to format yyyy-mm-dd to set value
      let y = dt.split('-');
      this.selectedDate = y[0] + '-' + y[1] + '-' + y[2];
      this.CheckValidations(this.selectedDate);

      //convert time to 12 hrs format to set value
      // let z = time.split(':');
      // let hour  = parseInt(z[0]);
      // let min = parseInt(z[1]);
      // hour = hour > 12 ? (hour - 12) : hour;
      // let modifiedhour = (hour+'').length == 1 ? `0${hour}` : hour;  
      // let modifiedMin = (min+'').length == 1 ? `0${min}` : min;
      // this.selectedTime = modifiedhour + ':' +modifiedMin;

      this.selectedTime = x[1];
    }
    else {
      let y = newDateTime.split('-');
      this.selectedDate = y[0] + '-' + y[1] + '-' + y[2];
     // this.selectedDate = newDateTime;
    }


  }
  onDateChange(value) {
    this.validationerrormessage = [];
    let newDate = new Date(value);
    newDate.setHours(0, 0, 0, 0);
    this.selectedDate = event.target["value"];
    //this.question["responseText"] = event.target["value"];
    this.CheckValidations(newDate);    //need to uncomment

    if (this.question.timeEnabled) {
      if (this.selectedTime.length == 0) {
        this.selectedTime = "12:00";
      }
    
      if (this.selectedDate != null) {
        this.question["responseText"] = this.selectedDate + ' ' + this.selectedTime;
      }
    }
    else {
      this.question["responseText"] = this.selectedDate;
    }


    this.childQuestion.emit(this.question);
    this.inputChange.emit(true);
  }
  onTimeChange(value) {

    this.validationerrormessage = [];

    //convert 24 hrs to 12 hrs format
    // let hour = (value.split(':'))[0]
    // let min = (value.split(':'))[1]
    // let part = hour > 12 ? 'PM' : 'AM';
    // if(parseInt(hour) == 0)
    //   hour = 12;
    //   min = (min+'').length == 1 ? `0${min}` : min;
    //   hour = hour > 12 ? hour - 12 : hour;
    //   hour = (hour+'').length == 1 ? `0${hour}` : hour;      
    // this.selectedTime =  `${hour}:${min} ${part}`;

    // if(part  == 'PM'){
    //   hour = hour < 12 ? hour + 12 : hour;
    //   min = (min+'').length == 1 ? `0${min}` : min;
    // }
    // this.selectedTime = `${hour}:${min}`;

    this.selectedTime = value;

    if (this.selectedTime.length == 0) {
      this.selectedTime = "12:00";
    }
    if (this.selectedDate != null && this.selectedTime != null) {
      this.question["responseText"] = this.selectedDate + ' ' + this.selectedTime;
      // this.question["selectedDate"] = this.selectedDate;
      // this.question["selectedTime"] = this.selectedTime;
      this.CheckValidations(this.selectedDate);
      this.childQuestion.emit(this.question);
    }
    else {
      (this.selectedDate == null || this.selectedDate.legth == 0) ? this.dateFlag = true : this.dateFlag = false;
      (this.selectedTime == null || this.selectedTime.legth == 0) ? this.timeFlag = true : this.timeFlag = false;
    }
    this.inputChange.emit(true);
  }
  CheckValidations(newDate: Date) {
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0)
    if (this.isConditionIsTrue === true) {
      if (this.question["responseText"] === "") {
        this.errormgvisible = true;
        this.question["IsValid"] = false;
      }
      else {
        this.errormgvisible = false;
        this.question["IsValid"] = true;
      }
    }
    else {
      this.question["IsValid"] = true;
      this.errormgvisible = false;
    }


    if (!this.question.pastDateEnabled && newDate < currentDate) {
      this.validationerrormessage.push("Past date is not allowed");
      this.errormgvisible = true;
      this.question["IsValid"] = false;
    }
    if (!this.question.todayDateEnabled && newDate.toString() == currentDate.toString()) {
      this.validationerrormessage.push("Today's date is not allowed");
      this.errormgvisible = true;
      this.question["IsValid"] = false;
    }
    if (!this.question.futureDateEnabled && newDate > currentDate) {
      this.validationerrormessage.push("Future date is not allowed");
      this.errormgvisible = true;
      this.question["IsValid"] = false;
    }
  }

}
